import { Route, Routes } from 'react-router-dom';
import { appRoutes, authRoutes } from './routes';
import Authenticate from './Authenticate';
import Profile from '../features/account/pages/Profile';
import Security from '../features/account/pages/Security';
import ErrorNotFound from './pages/ErrorNotFound';

function AppRoutes() {
    return (
        <Routes>
            {authRoutes.map((value, index) => {
                return <Route key={index} path={value.path} element={value.element}/>
            })}
            {appRoutes.flatMap((value, index) => {
                if (value.type === 'item') {
                    return [<Route key={index} path={value.path} element={<Authenticate>{value.element}</Authenticate>}/>];
                }
                if (value.type === 'children') {
                    return value.children.map((item, indexChildren) => (
                        <Route key={`${index}-${indexChildren}`} path={item.path} element={<Authenticate>{item.element}</Authenticate>}/>
                    ));
                }
                return [];
            })}
            <Route path={'/user/profile'} element={<Authenticate><Profile/></Authenticate>}/>
            <Route path={'/user/security'} element={<Authenticate><Security/></Authenticate>}/>
            <Route path={'*'} element={<ErrorNotFound/>}/>
        </Routes>
    );
}

export default AppRoutes;
